<template>
<!--  ClinicDetailPrescription-->
  <div class="consul-deal clearfix" style="position: relative">
    <div class="deal-content marginP">
      <div class="part-right consul-deal-part mypatient">
        <div  v-if="list.length>0"
          class="evaluate-wrap consul-sheet-wrap deal-sheet-wrap">
          <div>
            <div class="clearfix" style="background: #fff">
              <div class="launch-title1" style="background: #f9f9f9">
                <p>基本信息</p>
              </div>
              <div
                style="box-sizing: border-box; padding: 10px 20px 0"
                class="box-borders"
              >
                <div class="clearfix" style="height: 36px">
                  <span
                    class="name patient-list-item jet-black lineH30 fontSize14">{{list0.patname}}</span
                  >
                  <span class="patient-list-item lineH30 jet-gray">{{
                      list0.patsex
                  }}</span>
                  <span class="patient-list-item lineH30 jet-gray">{{list0.patage}}岁</span>
                  <span class="patient-list-item lineH30 jet-gray"
                    >患者病历号：{{ list0.medicalno }}</span
                  >
                </div>
<!--                <div class="clearfix" style="height: 36px">-->
<!--                  <span class="patient-list-item lineH30 jet-gray"-->
<!--                    >电话号码：{{-->
<!--                      consultDetailObj.compatMobile || ddxx.sjh-->
<!--                    }}</span-->
<!--                  >-->
<!--                  <span class="patient-list-item lineH30 jet-gray"-->
<!--                    >身份证：{{ ddxx.zjhm }}</span-->
<!--                  >-->
<!--                </div>-->
              </div>
            </div>
          </div>
          <div
            class="launch-title1"
            style="margin-top: 10px; background: #f9f9f9"
          >
            <p>处方信息</p>
          </div>
          <div
            style="box-sizing: border-box; padding: 10px 20px; background: #fff"
            class="box-borders"
          >

            <div v-for="(pres, index) in list" :key="index">
              <div class="part-head">
                <div class="left">处方{{index+1}} &nbsp;&nbsp; 类型: {{pres.drugstype}} &nbsp;&nbsp; 费用: {{pres.totalfree}}
                </div>
                <div class="right">
                  <div v-if="pres.isSignComplete==0" @click="genSign(pres)">生成签名</div>
                  <div v-if="pres.isSignComplete==1">
                    <a :href="pres.signPdfUrl" target="_blank">查看签名</a>
                  </div>
                </div>
              </div>
              <div class="prescription">
                <div class="prescription-item" v-for="(item, idx) in pres.drugsList":key="idx">
                  <div class="prescription-item-show">
                    <div class="pres">{{item.drugsname}} {{item.plasters}}{{item.unit}}</div>
                    <div class="pres-fee">费用: {{item.totalfee}} </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="list.length===0" class="empty">
          <div>未找到处方信息</div>
          <div @click="goBack" class="back">&lt;&lt;返回</div>
        </div>

      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<style lang="scss" scoped>
.part-head{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  font-size: 15px;
  font-weight: bold;
  .right{
    color: #00b2b1;
    >div{
      border: 1px solid #00b2b1;
      border-radius: 15px;
      padding: 5px 15px;
      cursor: pointer;
      a{
        color: #00b2b1;
      }
    }
  }
}
.prescription-item{
  width: 25%;
  float: left;
  .prescription-item-show{
    box-sizing: border-box;
    padding: 15px;
    margin: 5px;
    border: 1px solid #f2f2f2;
    border-radius: 5px;
    font-size: 16px;
    .pres-fee{
      padding-top: 10px;
      font-size: 14px;
      color: #666666;
    }
  }
}
.empty{
  padding: 15px;
  text-align: center;
  font-size: 14px;
  color: #666666;
  .back{
    font-size: 14px;
    color: #00b2b1;
    padding: 15px;
    cursor: pointer;
  }
}
</style>
<script>
import { getAgeFromIdCard, getSexFromIdCard } from "../../utils/filters";
import {onlineService} from "@/service/online";

export default {
  data() {
    return {
      list0: {},
      list: [],
      // page: {
      //   pageNum: 1,
      //   pageSize: 10,
      //   pages: 1,
      //   total: 0,
      // },
      // isSuccess: false,
      // consultDetailObj: {},
      // showBox: false,
      // imgList: [], //附件图片列表
      // fileList: [], //附件文件列表
      // /*上传图片*/
      // adviceImgList: [], // 咨询意见图片
      // adviceFileList: [], // 咨询意见附件
      // uploadFileCount: 0, //上传的文件数量，最大为9个
      // uploadData: {}, //up-load组件的data数据
      // imgUploadList: [], //需上传的图片列表
      // fileUploadList: [], //需上传的文件列表
      // attaIdList: [], //需要提交的附件列表
      // uploadUrl: API_URL, //上传图片action地址
      // tpwjdzs: [],
      // fjwjdzs: [],
      // list: [],
    };
  },
  computed: {
    // ddxx() {
    //   const { consultDetailObj } = this;
    //   if (consultDetailObj.ddxx && consultDetailObj.ddxx.code === "0") {
    //     return consultDetailObj.ddxx.obj;
    //   }
    //   return {};
    // },
    // upLoadList: function () {
    //   //获取上传图片和文件的id
    //   let imgUploadListArr = [];
    //   let fileUploadListArr = [];
    //   for (let i = 0; i < this.imgUploadList.length; i++) {
    //     imgUploadListArr.push(this.imgUploadList[i].response.obj);
    //   }
    //   for (let i = 0; i < this.fileUploadList.length; i++) {
    //     fileUploadListArr.push(this.fileUploadList[i].response.obj);
    //   }
    //   return this.adviceImgList.concat(imgUploadListArr, fileUploadListArr);
    // },
  },
  created: function () {
    //创建时获取会诊单数据
    // this.getConsultDetail();
  },
  watch: {},
  filters: { getAgeFromIdCard, getSexFromIdCard },
  components: {
  },
  mounted: function () {
    this.init();
  },
  methods: {
    async init() {
      const loading = this.$loading({
        lock: true,
        text: '数据加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let row = JSON.parse(sessionStorage.getItem("hosobj"))
      let reqObj = {
        orderId: row.ddid,
        hosId: row.yyid
      }
      let res = await onlineService.findPrescription(reqObj);
      loading.close();
      console.log(`======res=======>`, res, row)

      if (res.code == 0) {
        this.list = res.list
        this.list0 = res.list.length > 0 ? res.list[0] : {}
      }
    },
    async genSign(item){
      const loading = this.$loading({
        lock: true,
        text: '正在生成签名...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let row = JSON.parse(sessionStorage.getItem("hosobj"))
      let reqObj={
        orderId: row.ddid,
        hosId: row.yyid,
        identificationnumber: item.identificationnumber
      }
      let res = await onlineService.findPrescriptionPDFSign(reqObj);
      loading.close();
      console.log(`======genSign=======>`, res, row)
      if(res.code==0){
        this.$message({
          message: '签名生成成功!',
          type: 'success'
        });
        setTimeout(()=>{
          this.init();
        },1000)
      }
    },
    goBack(){
      this.$router.back();
    }
    // medical(item) {
    //   if(item.visitid==''){
    //     this.$message.error("没有就诊不可查看病历");
    //     return
    //   }
    //   this.$router.push({
    //     path: "/main/medicalList",
    //     query: { id: item.visitid },
    //   });
    // },
    // getDetails(item) {
    //   this.$store.state.prescription = item;
    //   this.$router.push({ path: "/main/prescriptionDetails" });
    // },
    // handleSizeChange(val) {
    //   this.page.pageSize = val;
    //   this.init();
    // },
    // onCurrentChange(pageNum) {
    //   this.page.pageNum = pageNum;
    //   this.init();
    // },

    // formatUnix: function (time) {
    //   //将unix时间戳转换未yyyy-MM-dd HH:mm
    //   return formatUnixTime(time);
    // },
    // async getConsultDetail() {
    //   //根据consultId获取会诊单数据
    //   let options = {
    //     id: JSON.parse(sessionStorage.getItem("hosobj")).ddid,
    //     // id:"10000907",
    //     token: localStorage.getItem("token"),
    //   };
    //   let data = await this.$http(
    //     "smarthos.online.outpatient.pack.info",
    //     options
    //   );
    //
    //   if (data.code == 0) {
    //     this.isSuccess = true;
    //     this.consultDetailObj = data.obj;
    //   }
    //   this.fileList = []; //清空内容，否则使用路由跳转页面不重载时，可能会多个单子的附件一起push进来
    //   this.imgList = []; //清空内容，否则使用路由跳转页面不重载时，可能会多个单子的附件一起push进来
    //   this.adviceImgList = [];
    //   this.adviceFileList = [];
    //   fileClassification(data.obj.attaList, this.imgList, this.fileList);
    //   fileClassification(
    //     data.obj.adviceAttaList,
    //     this.adviceImgList,
    //     this.adviceFileList
    //   ); // 获取咨询意见附件
    //   this.tpwjdzs = this.imgList;
    //   this.fjwjdzs = this.fileList;
    //   this.uploadFileCount = this.adviceImgList.length;
    // },
    // handleImageAmplify: function (index = 1, imgList = [], ev) {
    //   //图片放大
    //   let e = ev || event;
    //   let element = e.target || e.srcElement;
    //   let src = element.src;
    //   let obj = {
    //     imgList: imgList,
    //     index: index,
    //   };
    //   this.$store.dispatch("getAmplifyImageArr", obj); // 储存需要放大的数组，用于左右按钮切换
    //   imageAmplify(src);
    // },
  },
};
</script>
